import { Routes, Route } from 'react-router-dom'
import Header from './components/Header'
import Footer from './components/Footer'
import Home from './pages/Home'
import Create from './pages/Create'
import Dashboard from './pages/Dashboard'
import AuthGuide from './pages/AuthGuide'
import Profile from './pages/Profile'
import NFTModal from './components/NFTModal'

function App() {
  return (
    <div className="flex flex-col min-h-screen bg-luxury-navy-950">
      <Header />
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/create" element={<Create />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/authentication-guide" element={<AuthGuide />} />
        </Routes>
      </main>
      <Footer />
      <NFTModal />
    </div>
  )
}

export default App
